import { dateHandlers } from "@lib/utils/dateutils";
import { FormControl } from "@ecco/ui/form-control";
import { FormLabel } from "@ecco/ui/form-label";
import { Input } from "@ecco/ui/input";
import { Flex } from "@ecco/ui/flex";
import { Field } from "formik";
import { styles } from "./baseFormStyles";
import { Box } from "@ecco/ui/box";
import type { BirthDateProps } from "./baseFormsValidations";

export const BirthDateField = ({
    error,
    fieldValidity,
    header,
    dateFormat = "DD/MM/YYYY",
    placeholders,
}: BirthDateProps) => {
    const dateFieldsLayout = dateHandlers.dateFieldsLayout(dateFormat);

    const fieldsProps = {
        Month: {
            type: "text",
            placeholder: placeholders["Month"] || "MM",
        },
        Day: {
            type: "text",
            placeholder: placeholders["Day"] || "DD",
        },
        Year: {
            type: "text",
            placeholder: placeholders["Year"] || "YYYY",
        },
    };
    let hasError = false;

    const datesLayout = dateFieldsLayout.map((fieldName) => {
        if (fieldValidity[fieldName] || fieldValidity?.dateOfBirth) {
            hasError = true;
        }
        return (
            <FormControl key={fieldName} mt={0}>
                <FormLabel mt={4} sx={styles.formLabel} hidden={true}>
                    {header}
                </FormLabel>
                <Field
                    as={Input}
                    isInvalid={fieldValidity[fieldName]}
                    isRequired
                    id={fieldName}
                    name={fieldName}
                    sx={styles.birthdate}
                    {...fieldsProps[fieldName]}
                />
            </FormControl>
        );
    });
    return (
        <FormControl>
            <FormLabel mt={4} sx={styles.formLabel}>
                {header}
            </FormLabel>
            <Flex gap={5}>{datesLayout}</Flex>
            {hasError && <Box sx={styles.errorGroupMessage}>{error}</Box>}
        </FormControl>
    );
};

export default BirthDateField;
